(ns minorodata.utils)


(defn contains-value [list value]
  (some #{value} list))


(defn value-included [value list]
  (some #{value} list))


(defn fn-body? [form]
  (when (seq? form)
    true))


(defn func? [v]
  (when (and (list? v)
             (= 'fn (first v)))
    true))


(defn find-first [f coll]
  (reduce
   (fn [_ v]
     (when (f v)
       (reduced v)))
   nil
   coll))


(defn find-by-field [col field val]
  (find-first (comp #{val} field) col))


(defn find-all-by-field [col field val]
  (filter (comp some? #{val} field) col))


(defn find-index
  "Finds index of the first element of a col that matches the predicate f.
  Will return overflow index (last-idx+1) if it can't find anything."
  [f col]
  (count (take-while (complement f) col)))

(defn drop-nth [n coll]
  (keep-indexed #(when (not= %1 n) %2) coll))

(defn concat-two-keywords
  "Create keyword from two keywords"
  ([first second]
   (concat-two-keywords first second "-"))

  ([first second delim]
   (let [name1 (name first)
         ns1   (namespace first)
         name2 (name second)]
     (keyword ns1 (str name1 delim name2)))))


(defn conj-some
  "Conjoins each non-nil value."
  ([] [])
  ([coll] coll)
  ([coll x]
   (if (nil? x) coll (conj coll x)))

  ([coll x & more]
   (reduce conj-some (conj-some coll x) more)))


(defn deep-merge [a & maps]
  (if (map? a)
    (apply merge-with deep-merge a maps)
    (apply merge-with deep-merge maps)))
